// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1-JCn","Primary":"Button_Primary__yI2v5","Google":"Button_Google__i4dFn","Facebook":"Button_Facebook__3oa9A","EditProfile":"Button_EditProfile__3Btak"};